// extracted by mini-css-extract-plugin
export default {"bestWorst":"styles_bestWorst__fPIDP","title":"styles_title__zFn5+","tokens":"styles_tokens__pXyWD"};